import { Alert, Button, FormControl, FormLabel, Grid, LinearProgress, Snackbar, Stack, TextField, Typography } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Api from "../api/Api";
import { UserContext } from "../context/UserContextProvider";

const ALLOWED_DOMAINS = [
    'reddit.com',
    'instagram.com',
    'facebook.com',
    'twitter.com',
    'x.com',
    'linkedin.com',
    'pinterest.com',
    'pin.it',
    't.me'
]
const CreateSocialSharePage = () => {
    const navigate = useNavigate();
    const [isSending, setSending] = useState(false);
    const { user } = useContext(UserContext);
    const [earnStatus, setEarnStatus] = useState(undefined);
    const [link, setLink] = useState('');
    const [isValidLink, setIsValidLink] = useState(true);
    const [alertState, setAlertState] = useState({ show: false, success: true, message: [] })

    useEffect(() => {
        const fetch = async () => {
            setEarnStatus(await Api.isActive('social', user.idem_guid));
        }
        fetch();
    }, [user.idem_guid]);


    const handleCloseFormUpdateAlert = (/** @type {any} */ _event, /** @type {string} */ reason) => {
        if (reason === 'clickaway') {
            return
        }

        setAlertState({ show: false, success: true, message: [] })
    }

    const validateLink = (/** @type {string} */ newLink) => {
        if (newLink.length === 0) {
            setIsValidLink(false);
            return;
        }
        try {
            const url = new URL(newLink);
            if (!ALLOWED_DOMAINS.find(domain => url.host.endsWith(domain))) {
                setIsValidLink(false);
                return;
            }
        } catch (e) {
            setIsValidLink(false)
            return;
        }
        setIsValidLink(true);
    }

    const sendInvite = async () => {
        try {
            setSending(true);
            const campaign = await Api.createCampaign('social', [link], undefined, user.idem_guid);
            setAlertState({ show: true, success: true, message: ['The link was submitted.'] });
            setTimeout(() => {
                navigate(`/campaing/${campaign._id}`);
            }, 750);
        } catch (e) {
            setSending(false);
            const message = ['Could not submit the link.'];
            if (e?.response?.data?.error?.message) {
                message.push(e.response.data.error.message);
            }
            setAlertState({ show: true, success: false, message });
        }
    }

    if (!user || !earnStatus) {
        return <LinearProgress />;
    }

    return <Grid container spacing={2}>
        {!earnStatus.active && <Grid item xs={12}>
            <Alert severity='info' sx={{ mb: 2 }}>
                <Typography variant={'body1'}>
                    {`Your have reached the daily limit. Try again later.`}
                </Typography>
            </Alert>
        </Grid>}
        <Grid item xs={12} justifyContent={'center'} display={'flex'}>
            <Typography variant='h6' sx={{ color: 'white' }}>
                Share a tangled link in other social network and earn 50,000 mlx.
            </Typography>
        </Grid>
        <Grid item xs={12} color={'white'}>
            <Typography>{`Here's how to earn 50,000 mlx:`}</Typography>
            <Stack mt={1} pl={1}>
                <Typography>1. Choose any post on Tangled</Typography>
                <Typography>2. Share the Tangled post on any of the following platforms - reddit, instagram, facebook, X, linkedin, pinterest, telegram</Typography>
                <Typography>3. Enter the URL where you shared the Tangled post below</Typography>
                <Typography>4. Your share will be reviewed for payment approval</Typography>
            </Stack>
        </Grid>
        <Grid item xs={12}>
            <FormControl fullWidth error={!isValidLink}>
                <FormLabel sx={{ color: 'white' }} >Link</FormLabel>
                <TextField value={link} onChange={e => {
                    validateLink(e.target.value);
                    setLink(e.target.value);
                }} error={!isValidLink} />
            </FormControl>
        </Grid>
        <Grid item xs={12} justifyContent={'center'} display={'flex'}>
            <Button variant='contained' sx={{ minWidth: 200 }} onClick={sendInvite} disabled={link === '' || !isValidLink || isSending || !earnStatus?.active}>Send</Button>
        </Grid>
        {alertState.show && (
            <Snackbar
                open={alertState.show}
                autoHideDuration={4000}
                onClose={handleCloseFormUpdateAlert}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleCloseFormUpdateAlert}
                    severity={alertState.success ? 'success' : 'error'}
                    variant={'filled'}
                    elevation={6}
                    sx={{ width: '100%' }}
                >
                    {alertState.message.map((message, idx) => <Typography key={idx}>{message}</Typography>)}
                </Alert>
            </Snackbar>
        )}
    </Grid>
}

export default CreateSocialSharePage;